import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import Scrolltop from "../components/Scrolltop";
import Header from "../components/Header";

import Bg from "../img/defensiva2.jpg";

import BtWhatsapp from "../components/ButtonWhatsapp3";
import InvestigacaoDefensivaComp from "../components/InvestigacaoDefensivaComp";

const Defensiva = () => {
  return (
    <>
      <Header />
      
      <main>
        <Breadcrumb
          menu="Serviços"
          name="Investigação Defensiva" 
          bg={Bg}
        />
        <InvestigacaoDefensivaComp />
        <Footer />
      </main>
      <BtWhatsapp />
      <Scrolltop />
    </>
  );
};

export default Defensiva;
